import { Link } from 'react-router-dom';
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";

import ArtistIcon from '@/assets/all-icons/artist-icon';
import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import GalleryIcon from '@/assets/all-icons/gallery-icon';

import './styles/HomeLinks.css';

function HomeLink({ to, text, icon }) {

  return (
    <>
      <Link className="home-link__container no-underline" to={{
        pathname: to,
        state: { from: true }
      }}  >
        {icon}
        <span className="home-link__text">{text}</span>
      </Link>
    </>
  );
}

export default function HomeLinks() {
  return (
    <>
      <div className="home-links__container element-non-selectable">
        <HomeLink to="/galleries" text="Galleries" icon={<GalleryIcon className="home-links__icon gallery" />} />
        <HomeLink to="/artists" text="Artists" icon={<ArtistIcon className="home-links__icon artist" />} />
        <HomeLink to="/artworks" text="Artworks" icon={<ArtworkIcon className="home-links__icon artwork" />} />
        <HomeLink to="/artlists" text="Artlists" icon={<ArtlistIcon className="home-links__icon artlist" />} />
      </div>
    </>
  );
}
